// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1qk0j","footer":"Form_footer__2WGGD"};